<template>
  <el-container>
    <el-main style="width: 90%">
      <div style="margin-bottom: 10px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">个人设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">个人快捷回复</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="searchBox">
        <el-form label-width="0">
          <el-form-item label="">
            <el-input
              size="mini"
              v-model="input3"
              placeholder="输入内容搜索"
              suffix-icon="el-icon-search"
              @input="inputContent"
            ></el-input>
          </el-form-item>
          <el-form-item label="" style="width: 70%; min-width: 350px">
            <el-button
              type="primary"
              size="mini"
              @click="deleteAll"
              class="item_font"
              >一键删除</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="importAction"
              class="item_font"
              >导入</el-button
            >
            <!-- <el-button type="primary" size="mini" @click="importQuickReply">引入</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="exportAction"
              class="item_font"
              >导出</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="addFolder"
              class="item_font"
              >新建目录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div style="width: 100%">
        <el-table
          :data="showData"
          border
          highlight-current-row
          row-key="id"
          :cell-class-name="cloumn2Class"
          style="width: 100%"
          :header-cell-style="headerStyle"
          v-loading="loading"
          :max-height="tableHeight"
          :cell-style="cellStyle"
          :indent="10"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-click="thisRowClick"
          ref="tableRef"
        >
          <el-table-column width="120" property="index" label="序号" sortable>
          </el-table-column>
          <el-table-column property="title" label="标题"></el-table-column>
          <el-table-column property="content" label="内容"></el-table-column>
          <!-- <el-table-column property="sort" label="使用频率" sortable="" width="150"></el-table-column> -->
          <el-table-column property="operate" label="操作" width="220px">
            <template slot-scope="scope">
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-around;
                "
              >
                <el-button
                  v-show="scope.row.dataType == 0"
                  type="text"
                  size="small"
                  @click="add(scope)"
                  class="item_font"
                  >添加</el-button
                >
                <div
                  v-show="scope.row.dataType == 1"
                  style="text-align: center"
                >
                  <span style="color: rgba(255, 255, 255, 0); user-select: none"
                    >添加</span
                  >
                </div>
                <el-button
                  type="text"
                  size="small"
                  @click="handleEdit(scope.$index, scope.row)"
                  class="item_font"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click.native.prevent="deleteRow(scope.row)"
                  class="item_font"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="up(scope.row)"
                  class="item_font"
                  >移动</el-button
                >
                <!-- <el-button type="text" size="small" @click="down(scope)">下移</el-button> -->
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column property="sortNum" label="排序序号" width="100px">
						<template slot-scope="scope">
							<div>
								<el-input v-model="scope.row.sortNum" onkeyup="value=value.replace(/[^\d]/g,'')" size="mini" @blur="changeSort(scope.row)"></el-input>
							</div>
						</template>
					</el-table-column> -->
        </el-table>
      </div>
      <div class="item_font" v-show="addFolders">
        <el-dialog
          :title="act"
          :visible.sync="addFolders"
          width="60%"
          center
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <el-form
            :model="fileData"
            label-position="left"
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-left: 30px;
              margin-right: 30px;
            "
          >
            <el-form-item label="目录标题:">
              <el-input v-model="fileData.title" style="width: 70%"></el-input>
            </el-form-item>
            <!-- <el-form-item label="排列序号:" >
							<el-input v-model="fileData.sortNum"  style="width: 70%;" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字0~9999"></el-input>
						</el-form-item> -->
            <el-form-item label="回复内容:" v-show="fileData.dataType === 1">
              <el-input
                v-model="fileData.content"
                type="textarea"
                style="width: 70%"
                :autosize="{ minRows: 5, maxRows: 10}"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-model="fileData.pId"
              v-show="fileData.dataType === 0"
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
              "
            >
              <el-checkbox
                label="放在当前选定的目录下"
                v-model="noRoot"
                @change="handleCheckNoRoot"
                :disabled="tableData.length == 0 || rowId == ''"
              ></el-checkbox>
              <el-checkbox
                label="放在根目录下"
                v-model="isRoot"
                @change="handleCheckIsRoot"
              ></el-checkbox>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              @click="
                addFolders = false;
                resetForm();
              "
              class="item_font"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="condirmAddFolder"
              class="item_font"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div class="item_font" v-show="addReply">
        <el-dialog
          :title="act"
          :visible.sync="addReply"
          width="60%"
          center
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
          "
        >
          <el-form
            :model="replyData"
            label-position="left"
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-left: 30px;
              margin-right: 30px;
            "
          >
            <el-form-item label="回复标题:">
              <el-input v-model="replyData.title" style="width: 80%"></el-input>
            </el-form-item>
            <!-- <el-form-item label="排列序号:" >
							<el-input v-model="replyData.sortNum" style="width: 80%;" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder="请输入数字0~9999"></el-input>
						</el-form-item> -->
            <el-form-item
              label="回复内容:"
              v-show="dataType == 0 ? false : true"
            >
              <el-input
                v-model="replyData.content"
                type="textarea"
                style="width: 80%"
                :autosize="{ minRows: 5, maxRows: 10}"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addReply = false" class="item_font"
              >取 消</el-button
            >
            <el-button type="primary" @click="condirmAddReply" class="item_font"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div class="item_font" v-show="isImport">
        <el-dialog
          class=".pub_dialog"
          title="引入快捷回复"
          :visible.sync="isImport"
          @close="cancelImportReply"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div class="data_trees">
            <div
              class="left_tree"
              style="
                width: 35%;
                height: auto;
                min-height: 200px;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <el-tree
                :data="leftTreeData"
                ref="leftTree"
                :indent="18"
                node-key="id"
                show-checkbox
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span
                    :class="data.pId == '0' ? 'node_class1' : 'node_class2'"
                    >{{ node.label }}</span
                  >
                </span>
              </el-tree>
            </div>
            <div class="arrows">
              <div
                class="right_arrow"
                style="cursor: pointer"
                @click="handleCheckChange"
              >
                &gt;&gt;
              </div>
              <div
                class="left_arrow"
                style="cursor: pointer"
                @click="handleCheckDelete"
              >
                &lt;&lt;
              </div>
            </div>
            <div
              class="left_tree"
              style="
                width: 35%;
                height: auto;
                min-height: 200px;
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <el-tree
                :data="rightTreeData"
                ref="rightTree"
                :indent="18"
                node-key="id"
                show-checkbox
                :draggable="true"
                @node-drag-start="handleDragStart"
                @node-drag-enter="handleDragEnter"
                @node-drag-leave="handleDragLeave"
                @node-drag-over="handleDragOver"
                @node-drag-end="handleDragEnd"
                @node-drop="handleDrop"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span
                    :class="data.pId == '0' ? 'node_class1' : 'node_class2'"
                    >{{ node.label }}</span
                  >
                </span>
              </el-tree>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="cancelImportReply" class="item_font"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="condirmImportReply"
              class="item_font"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
      <div v-show="showImport" class="item_font">
        <el-dialog
          title="上传文件到服务器"
          :visible.sync="showImport"
          width="50%"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            ref="upload"
            :on-success="uploadSuccess"
            :data="importType"
            :headers="myHeaders"
            :file-list="fileList"
            :before-upload="beforeUpload"
            accept=".xls,.xlsx"
            style="width: 60%; margin: 0 auto; margin-bottom: 3.125rem"
          >
            <el-button size="small" type="primary" class="item_font"
              >点击上传文件</el-button
            >
            <div slot="tip" class="el-upload__tip item_font">
              支持上传xls和xlsx格式的文件
            </div>
          </el-upload>
        </el-dialog>
      </div>
      <div
        style="
          display: flex;
          flex-direction: row;
          width: 60%;
          margin-left: 20%;
          margin-top: 3%;
          justify-content: space-around;
        "
      >
        <el-pagination
          background
          :pager-count="9"
          :page-size="10"
          layout="prev, pager, next, total"
          :total="total"
          @prev-click="pre"
          @next-click="next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <div class="item_font">
        <el-dialog
          title="移动位置"
          :visible.sync="sortNum"
          width="400px"
          center
          :close-on-click-modal="false"
          :close-on-press-escape="false"
        >
          <div style="display: flex; width: 300px; margin-left: 50px">
            <span style="line-height: 30px" class="item_font">移动到第</span>
            <el-input
              size="mini"
              v-model="sortNumValue"
              style="width: 120px; margin-left: 20px; margin-right: 20px"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              placeholder="输入数字"
            ></el-input>
            <span style="line-height: 30px" class="item_font">行</span>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="sortNum = false" size="mini" class="item_font"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="condirmSortnum"
              size="mini"
              class="item_font"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { MessageBox } from "element-ui";
import $ from "jquery";
export default {
  data() {
    return {
      start: 0,
      page: 1,
      total: 0,
      checkedRightNodes: [],
      checkedRightNodesIds: [],
      act: "",
      input3: "",
      addFolders: false,
      addReply: false,
      noRoot: false,
      isRoot: true,
      isImport: false,
      rowId: "",
      currentType: "",
      fileData: {
        id: "",
        pId: "0",
        title: "",
        content: "",
        attributionType: 1,
        dataType: 0,
      },
      tableData: [],
      replyData: {
        id: "",
        pId: 0,
        title: "",
        content: "",
        attributionType: 1,
        dataType: 1,
        // sortNum:200,
      },
      leftTreeData: [],
      rightTreeData: [],
      // 查询相关
      selData: {
        page: 1,
        id: null,
        attributionType: 1,
        userId: this.util.getLocalAccount().id,
      },

      importType: {
        attributionType: 1,
        userId: this.util.getLocalAccount().id,
      },
      //导入功能
      showImport: false,
      // uploadUrl: 'http://192.168.0.182:8050/manager/QuickReplyQuery/excelImport',
      // // uploadUrl:JSON.parse(localStorage.getItem("siteObj")).webUrl  + '/manager/fileInfo/pass/upload',
      uploadUrl:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/QuickReplyQuery/excelImport",
      myHeaders: {
        Authorization: localStorage.getItem("token"),
      },
      fileList: [],
      showData: [{ dataType: 0 }],
      dataType: 0,
      loading: true,
      sortNum: false,
      sortNumValue: "",
      key: 1,
      tableHeight: 400,
      showDataIsChange: false,
    };
  },
  watch: {
    // 监听快捷回复数据展示状态
    showData: {
      handler() {
        this.showDataIsChange = !this.showDataIsChange;
        localStorage.setItem("quickReplyISchange", this.showDataIsChange);
      },
      deep: true,
    },
  },

  mounted() {
    console.log("quick mounted uploadUrl = ", this.uploadUrl);
    this.quickReplySel();
    this.$nextTick(() => {
      var seaH = $(".searchBox").height();
      this.tableHeight = window.innerHeight - seaH - 180;
      window.addEventListener("resize", () => {
        //监听浏览器窗口大小改变
        //浏览器变化执行动作
        var seaH = $(".searchBox").height();
        this.tableHeight = window.innerHeight - seaH - 180;
      });
    });
  },
  methods: {
    cloumn2Class({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 1) {
        console.log(
          "=====================",
          row,
          column,
          rowIndex,
          columnIndex
        );
        return "cloumn2Class";
      }
    },
    headerStyle({ rowIndex, columnIndex }) {
      if (rowIndex == 0 && columnIndex == 3) {
        return "text-align:center;color:#000000";
      } else {
        return "text-align:left;padding:15px;color:#000000";
      }
    },

    cellStyle({ columnIndex }) {
      if (columnIndex == 3 || columnIndex == 0) {
        return "text-align:center";
      } else {
        return "text-align:left;padding:15px;";
      }
    },

    importAction() {
      this.showImport = true;
    },
    async exportAction() {
      var api = "/manager/quickReply/exportToExcel";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
        responseType: "arraybuffer",
      });
      console.log(response);
      let blob = new Blob([response], { type: "application/vnd.ms-excel" });
      let fileName = this.util.getLocalAccount().realName + "快捷回复" + ".xls";
      this.downFile(blob, fileName);
    },
    downFile(blob, fileName) {
      if (this.$nodeFs) {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        console.log("electron 环境", fileName);
        reader.addEventListener("loadend", () => {
          const filePath = reader.result;
          const ipc = this.$electron.ipcRenderer;
          ipc.send("downLoad", {
            filePath,
            fileName,
          });
          
          console.log("electron loadend", filePath);
        });
      } else {
        console.log("非electron环境", fileName);
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      }
    },

    beforeUpload(file) {
      console.log("beforeUpload", file);
      const isJPG = file.type === "excel" || "xls" || "xlsx";
      const isLt10M = file.size < 1024 * 1024 * 10;
      if (!isJPG) {
        this.$message.error("只能上传xls格式文件!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传的文件大小不能超过 10MB!");
        return false;
      }
    },

    uploadSuccess(res, file) {
      console.log("quick uploadSuccess res = ", res, file);
      if (res.resultCode === "10000") {
        const tipMsg = "导入文件成功!";
        this.$message.success(tipMsg);
        this.showImport = false;
        this.$refs.upload.clearFiles();
        this.quickReplySel();
      } else {
        this.$refs.upload.clearFiles();
        this.$message.error(res.desc);
      }

      // this.form.logoUrl = this.util.BASE_IMAGE_URL  + res.data.fileUrl
      // console.log("图片URL",this.form.logoUrl)
      // console.log("上传图片成功",res)
      // console.log(file)
    },

    // 获取快捷回复内容
    async quickReplySel(payload, row) {
      console.log(payload, row);
      console.log("Quick Reply Select");
      console.log("Quick Reply Select userId", this.selData.userId);
      var api = "/manager/quickReply/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.selData,
      });
      for (var i = 0; i < response.data.length; i++) {
        this.getTree(i, response.data[i]);
      }
      // var result=this.getQuee(response.data)
      this.tableData = response.data;
      this.total = this.tableData.length;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
      this.loading = false;
      //   if (payload === "删除") {
      // 	if(){

      // 	}
      //     if (Number(row.index) === this.tableData.length + 1) {
      //       console.log(Number(row.index) === this.tableData.length);
      //       this.rowId = this.tableData[this.tableData.length - 1].id;
      //       console.log(row.index, this.rowId);
      //       this.$refs.tableRef.setCurrentRow(row);
      //     } else {
      //       console.log("2222");
      //     }
      //   }
      //   console.log("个人快捷回复数据", response.data);
    },

    getTree(index, data) {
      data.children = data.quickReplyVoList;
      data.label = data.title;
      data.number = index + 1;
      if (data.children != null) {
        data.index = String(index + 1);
        for (var i = 0; i < data.children.length; i++) {
          this.getTree(i, data.children[i]);
        }
      } else {
        data.index = "\xa0\xa0\xa0\xa0\xa0\xa0" + String(index + 1);
      }
    },
    // async getQuee(data) {
    // 	console.log(21111111111112)
    // 	let result = [];
    // 	let queue = data;
    // 	let level = 0
    // 	while (queue.length > 0) {
    // 		level += 1
    // 		;[...queue].forEach((child, i) => {
    // 			queue.shift();
    // 			child.level = level
    // 			child.index = i+1
    // 			console.log("kkkkkkkkkkkk",i)
    // 			console.log(222222222222,child)
    // 			result = result.concat([child])
    // 			child.children && (queue.push(...child.children));
    // 		})
    // 	}
    // 	console.log(333333333333,result)
    // 	return result
    // },
    // 添加目录/快捷回复
    async addFolder() {
      console.log(this.currentType);
      //   if (this.rowId !== "") {
      //     this.noRoot = true;
      //     this.isRoot = false;
      //   } else {
      //     this.noRoot = false;
      //     this.isRoot = true;
      //   }
      if (this.currentType != 1) {
        this.fileData.dataType = 0;
        this.act = "新建目录";
        this.set();
      } else {
        let tipMsg = "不能在内容下创建目录，请重新选择";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "error",
          showCancelButton: false,
        });
      }
    },
    handleCheckNoRoot() {
      if (this.noRoot) {
        this.fileData.pId = this.rowId;
        this.isRoot = false;
        this.noRoot = true;
      } else {
        this.fileData.pId = "0";
        this.noRoot = false;
        this.isRoot = true;
      }
      console.log("根目录", this.isRoot);
      console.log(this.noRoot);
    },
    handleCheckIsRoot() {
      if (this.isRoot) {
        this.isRoot = true;
        this.noRoot = false;
      } else {
        this.noRoot = true;
        this.isRoot = false;
      }
      console.log("根目录", this.isRoot);
      console.log(this.noRoot);
    },
    async condirmAddFolder() {
      console.log("condirmAddFolder", this.fileData);
      // console.log(this.isRoot)
      if (this.fileData.pId != "") {
        if (this.fileData.title != "") {
          var api = "/manager/quickReply/add";
          this.fileData.sortNum = Number(this.fileData.sortNum);
          const response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.fileData,
          });

          if (response.resultCode === "10000") {
            if (this.fileData.dataType == 1) {
              this.$message.success("新增回复成功");
            } else {
              this.$message.success("创建目录成功");
            }
            this.addFolders = false;
            this.fileData = {
              pId: "0",
              title: "",
              content: "",
              attributionType: 1,
              dataType: 0,
              sortNum: "",
            };
            this.isRoot = true;
            this.noRoot = false;
            this.quickReplySel();
          } else {
            this.$message.error(response.desc);
          }
        } else {
          const tipMsg = "目录标题不能为空";
          MessageBox.alert(tipMsg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: null,
            type: "warning",
            showCancelButton: false,
          });
        }
      } else {
        const tipMsg = "请选择正确的目录位置";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },

    // 添加回复
    async add(scope) {
      console.log(scope);
      this.fileData.dataType = 1;
      this.fileData.pId = scope.row.id;
      // this.fileData.sortNum = ""
      this.fileData.title = "";
      this.fileData.content = "";
      this.act = "新增快捷回复标题";
      this.set();
    },
    set() {
      this.addFolders = true;
    },

    // 编辑回复
    handleEdit(index, row) {
      console.log(index, row);
      this.addReply = true;
      this.replyData = {
        id: row.id,
        // pId: row.pId,
        title: row.title,
        content: row.content,
        // attributionType: 1,
        // dataType: row.dataType,
        // sortNum:Number(row.sortNum)
      };
      this.dataType = row.dataType;
      if (row.pId === "0") {
        this.act = "编辑快捷回复标题";
      } else {
        this.act = "编辑快捷回复内容";
      }
    },

    // 提交编辑、添加回复的内容
    async condirmAddReply() {
      this.sortNumValue = "";
      if (this.replyData.title != "") {
        var api = "";
        var response = {};
        if (this.act == "编辑快捷回复标题" || this.act == "编辑快捷回复内容") {
          api = "/manager/quickReply/edit";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        } else {
          api = "/manager/quickReply/add";
          response = await this.util.postRequest({
            url: api,
            method: "POST",
            data: this.replyData,
          });
        }
        if (response.resultCode === "10000") {
          this.replyData = {
            id: "",
            pId: 0,
            title: "",
            content: "",
            attributionType: 1,
            dataType: 1,
          };
          this.addReply = false;
          this.act = "";
          this.quickReplySel();
          this.$message.success("保存成功");
        } else {
          this.$message.error(response.desc);
        }
      } else {
        const tipMsg = "标题不能为空";
        MessageBox.alert(tipMsg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: null,
          type: "warning",
          showCancelButton: false,
        });
      }
    },

    // 删除回复
    deleteRow(row) {
      const tipMsg = "是否确认删除";
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
      })
        .then(() => {
          this.deleteReply(row.id, row);
          if (!row.children || row.pId !== "0") {
            this.rowId = "";
          } else {
            this.rowId = row.pId;
          }
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
    async deleteReply(id, row) {
      var api = "/manager/quickReply/del";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          id: id,
        },
      });
      console.log(response);
      if (response.resultCode === "10000") {
        const tipMsg = "删除快捷回复成功!";
        this.$message.success(tipMsg);
      } else {
        this.$message.error(response.desc);
      }
      this.quickReplySel("删除", row);
    },

    // 上移下移回复
    async up(row) {
      console.log("更改排列序号", row);
      // this.replyData.sortNum = row.sortNum
      // this.sortNumValue.value = this.replyData.sortNum
      this.act = "编辑快捷回复标题";
      this.replyData = {
        id: row.id,
        // pId: row.pId,
        title: row.title,
        content: row.content,
        // attributionType: 1,
        // dataType: row.dataType,
      };
      this.sortNum = true;
    },
    async upAndDown() {
      var api = "/manager/quickReply/upAndDown";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: this.replyData,
      });
      if (response.resultCode === "10000") {
        this.$message.success("移动成功");
        this.quickReplySel();
      } else {
        this.$message.error(response.desc);
      }
    },
    //编辑排序
    condirmSortnum() {
      this.replyData.sortNum = Number(this.sortNumValue);
      // console.log(1111111111,this.replyData)
      this.upAndDown();
      this.sortNum = false;
    },

    // 搜索内容
    async inputContent(value) {
      console.log("当前输入内容", value);
      if (value != "") {
        var api = "/manager/QuickReplyQuery/selectByContent";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            attributionType: 1,
            content: value,
          },
        });
        if (response.resultCode === "10000") {
          this.tableData = [];
          // this.tableData.push(response.data.listVos)
          for (var i = 0; i < response.data.listVos.length; i++) {
            this.tableData.push(response.data.listVos[i]);
            this.total = this.tableData.length;
            // console.log("搜索结果", this.tableData)
          }
          this.showData = this.tableData.slice(
            (this.page - 1) * 10,
            this.page * 10 - 1
          );
        }
      } else {
        this.quickReplySel();
      }
    },
    // 点击表格的某一行
    thisRowClick(row) {
      this.currentType = row.dataType;
      this.rowId = row.id;
      console.log(this.rowId, row);
    },

    // 取消引入快捷回复
    cancelImportReply() {
      this.isImport = false;
      this.rightTreeData = [];
    },
    // // 引入快捷回复
    async importQuickReply() {
      this.isImport = true;
      // 获取快捷回复内容
      console.log("Quick Reply Select");
      var api = "/manager/quickReply/select";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          attributionType: 0,
        },
      });
      for (var i = 0; i < response.data.length; i++) {
        this.getTree(response.data[i]);
      }
      this.leftTreeData = response.data;
      console.log("公共库快捷回复数据", response.data);
    },

    // 选定快捷回复
    handleCheckChange() {
      this.rightTreeData = this.$refs.leftTree.getCheckedNodes();

      console.log("右树", this.rightTreeData);
    },

    // 获得要删除选中的快捷回复节点
    getDeleteNodes() {
      this.checkedRightNodes = this.$refs.rightTree.getCheckedNodes();
      this.checkedRightNodes.forEach((item) => {
        this.checkedRightNodesIds.push(item.id);
      });
      console.log(this.checkedRightNodes);
    },
    // 删除选中的快捷回复节点
    CheckedDelete(data, ids) {
      for (var m = 0, n = data.length; m < n; m++) {
        for (var i = 0, j = ids.length; i < j; i++) {
          if (data[m] && data[m].id === ids[i]) {
            data.splice(m, 1);
          }
        }
        if (data[m] && data[m].children != null) {
          this.CheckedDelete(data[m].children, ids);
        }
      }
      return data;
    },
    // 拖拽节点相关方法
    handleCheckDelete() {
      this.getDeleteNodes();
      this.CheckedDelete(this.rightTreeData, this.checkedRightNodesIds);
      console.log(this.rightTreeData);
    },
    handleDragStart(node, ev) {
      console.log("drag start", node, ev);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      console.log("tree drag enter: ", dropNode.label, ev);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      console.log("tree drag leave: ", dropNode.label, ev);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      console.log("tree drag over: ", dropNode.label, ev);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      console.log("tree drag end: ", dropNode && dropNode.label, dropType, ev);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label, dropType, ev);
    },
    // 引入数据接口
    async condirmImportReply() {
      console.log("Quick Reply Select");
      var api = "/manager/quickReply/quote";
      console.log("引入数据列表", this.rightTreeData);
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          pId: "0",
          dataType: 1,
          quickReplyDTOList: this.rightTreeData,
          userId: this.util.getLocalAccount().id,
        },
      });
      console.log("引入数据结果:", response);
      this.quickReplySel();
      this.isImport = false;
    },
    // 分页器相关方法
    pre(info) {
      console.log("pre：", info);
      this.page = info;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
    next(info) {
      console.log("next：", info);
      this.page = info;
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
    handleCurrentChange(val) {
      this.start = 4 * (val - 1);
      this.page = val;
      console.log("当前页码：", val, this.start);
      this.showData = this.tableData.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
    deleteAll() {
      const tipMsg =
        '<p class="item_font">本操作会清空所有的快捷回复并且不可恢复，建议先使用导出功能备份一下在删除。</p><br><strong>确定要清空么？</strong>';
      MessageBox.alert(tipMsg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showCancelButton: true,
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          console.log("confirm delete button");
          this.deleteQuickAll();
        })
        .catch(() => {
          this.$message.info("取消删除");
        });
    },
    async deleteQuickAll() {
      var api = "/manager/quickReply/delBatchByAttrType";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });
      console.log("deleteQuickAll response", response);
      if (response.resultCode === "10000") {
        this.quickReplySel();
        const tipMsg = "删除快捷回复成功!";
        this.$message.success(tipMsg);
      } else {
        this.$message.error(response.desc);
      }
    },
    getIndex($index) {
      return (this.page - 1) * 10 + $index + 1;
    },

    resetForm() {
      this.fileData = {
        id: "",
        pId: "0",
        title: "",
        content: "",
        attributionType: 1,
        dataType: 0,
        // sortNum:"",
      };
    },
  },
};
</script>

<style lang="scss">
.data_trees {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.arrows {
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.right_arrow {
  width: 30px;
  height: 20px;
  font-size: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  line-height: 40px;
}

.left_arrow {
  width: 30px;
  height: 20px;
  font-size: 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  line-height: 40px;
}

.node_class1 {
  font-size: 18px;
  /* font-weight: 550; */
}

.node_class2 {
  font-size: 16px;
}

.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;

  .el-dialog {
    margin: 0 auto !important;
    height: 90%;
    overflow: hidden;

    .el-dialog__body {
      position: absolute;
      left: 0;
      top: 54px;
      bottom: 0;
      right: 0;
      padding: 0;
      z-index: 1;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
.cloumn2Class {
  font-weight: 600;
}
</style>
